module.exports = __webpack_public_path__ + "static/media/bP.876f1ece.svg";